{
  "friendsScreen": {
    "tabs": {
      "suggestions": "Sugestões",
      "search": "Pesquisa",
      "requests": "Pedidos"
    },
    "common": {
      "loading": "Carregando…"
    },
    "suggestions": {
      "sectionTitle": "Pessoas que você pode conhecer",
      "empty": "Nenhuma sugestão no momento",
      "endOfList": "— Fim das sugestões —"
    },
    "search": {
      "placeholder": "Pesquisar por nome ou sobrenome…",
      "sectionTitle": "Resultados da pesquisa",
      "noResults": "Nenhum resultado para \"{{query}}\"",
      "hint": "Encontre novas pessoas"
    },
    "requests": {
      "receivedTab": "Recebidos ({{count}})",
      "sentTab": "Enviados ({{count}})",
      "receivedSubtitle": "Deseja se conectar com você",
      "sentSubtitle": "Você enviou um pedido",
      "emptyReceived": "Nenhum pedido novo",
      "emptySent": "Nenhum pedido pendente",
      "accept": "Aceitar",
      "decline": "Recusar",
      "cancel": "Cancelar"
    }
  },
  "messagesScreen": {
    "defaultUserName": "Eu",
    "loadingData": "Carregando dados",
    "you": "Você:",
    "tabs": {
      "history": "Histórico",
      "online": "Online",
      "friends": "Amigos",
      "groups": "Grupos"
    },
    "search": {
      "placeholderHistory": "Pesquisar uma conversa",
      "placeholderOnline": "Pesquisar um amigo online",
      "placeholderFriends": "Pesquisar um amigo",
      "placeholderGroups": "Pesquisar um grupo"
    },
    "status": {
      "online": "Online",
      "offline": "Offline"
    },
    "preview": {
      "noMessage": "Nenhuma mensagem",
      "photo": "📷 Foto",
      "video": "🎬 Vídeo",
      "audio": "🎵 Áudio",
      "file": "📁 Arquivo"
    },
    "time": {
      "now": "Agora mesmo",
      "minutes_one": "{{count}}min",
      "minutes_other": "{{count}}min",
      "hours_one": "{{count}}h",
      "hours_other": "{{count}}h",
      "days_one": "{{count}}d",
      "days_other": "{{count}}d"
    },
    "empty": {
      "noResultsTitle": "Nenhum resultado",
      "noConversationsFor": "Nenhuma conversa para \"{{query}}\"",
      "noMessagesTitle": "Você não tem mensagens",
      "noMessagesSubtitle": "Comece uma conversa com seus amigos",
      "noOnlineFriendsFor": "Nenhum amigo online para \"{{query}}\"",
      "noOnlineFriendsTitle": "Nenhum amigo online",
      "noFriendsFor": "Nenhum amigo para \"{{query}}\"",
      "noFriendsTitle": "Nenhum amigo"
    },
    "sync": {
      "titleInProgress": "Sincronização em andamento",
      "titleDone": "Dados atualizados",
      "titleError": "Falha na sincronização",
      "done": "Sincronização concluída",
      "genericError": "Ocorreu um erro.",
      "steps": {
        "checking": "Inicializando…",
        "refreshing": "Atualizando…",
        "syncing": "Sincronizando dados…",
        "syncingData": "Sincronização de dados"
      },
      "errors": {
        "pleaseReconnectData": "Faça login novamente para acessar seus dados.",
        "pleaseReconnect": "Faça login novamente.",
        "cannotRefresh": "Não foi possível atualizar os dados. Faça login novamente.",
        "userNotFound": "Identificador de usuário não encontrado. Faça login novamente.",
        "syncFailed": "Ocorreu um erro durante a sincronização. Verifique sua conexão e tente novamente."
      }
    }
  },
  "profileScreen": {
    "loading": "Carregando...",
    "retry": "Tentar novamente",
    "memberSince": "Membro desde {{date}}",
    "errors": {
      "cannotLoadProfile": "Não foi possível carregar o perfil"
    },
    "roles": {
      "supreme": "⚡ Supreme",
      "adminPro": "👑 Admin PRO",
      "admin": "🛡 Administrador",
      "pro": "⭐ Usuário PRO"
    },
    "stats": {
      "cfa": "CFA",
      "trophies": "Troféus"
    },
    "account": {
      "sectionLabel": "MINHA CONTA",
      "topUp": {
        "title": "Recarregar meu saldo",
        "sub": "Rápido · Seguro · Mobile Money"
      },
      "settings": {
        "title": "Ajustes",
        "sub": "Nome, sobrenome, data de nascimento"
      },
      "privacy": {
        "title": "Privacidade",
        "sub": "Privacidade, dados e segurança"
      },
      "guide": {
        "title": "Guia de uso",
        "sub": "Tudo sobre a Harmonia"
      }
    },
    "info": {
      "sectionLabel": "INFORMAÇÕES",
      "lastName": "Sobrenome",
      "firstName": "Nome",
      "birthDate": "Data de nascimento"
    },
    "posts": {
      "title": "Publicações ({{count}})",
      "publishButton": "Publicar",
      "emptyTitle": "Nenhuma publicação",
      "emptySub": "Compartilhe sua primeira publicação!"
    },
    "post": {
      "tapToPlay": "Toque para reproduzir",
      "commentsCount_one": "{{count}} comentário",
      "commentsCount_other": "{{count}} comentários",
      "sharesCount_one": "{{count}} compartilhamento",
      "sharesCount_other": "{{count}} compartilhamentos"
    },
    "postDetails": {
      "title": "📊 Detalhes",
      "author": "Autor:",
      "published": "Publicado:",
      "reactions": "Reações:",
      "close": "Fechar"
    },
    "avatar": {
      "updated": "Foto de perfil atualizada!",
      "errors": {
        "accessRequired": "Acesso às fotos necessário.",
        "cannotUpdate": "Não foi possível atualizar a foto"
      }
    },
    "createPost": {
      "title": "Nova publicação",
      "placeholder": "O que há de novo?",
      "photo": "Foto",
      "video": "Vídeo",
      "videoReady": "Vídeo pronto",
      "publish": "Publicar",
      "published": "Publicação publicada!",
      "imageAdded": "Imagem adicionada!",
      "videoAdded": "Vídeo adicionado!",
      "visibility": {
        "public": "Público",
        "friends": "Amigos",
        "pro": "PRO",
        "private": "Privado"
      },
      "errors": {
        "contentRequired": "O conteúdo é obrigatório",
        "limitReached": "Limite de publicações atingido.",
        "cannotPublish": "Não foi possível publicar",
        "mediaAccessRequired": "Acesso à mídia necessário.",
        "cannotAddMedia": "Não foi possível adicionar a mídia"
      }
    },
    "settings": {
      "header": {
        "title": "Ajustes",
        "subtitle": "Editar suas informações pessoais"
      },
      "updated": "Perfil atualizado!",
      "fields": {
        "lastName": "Sobrenome",
        "lastNamePlaceholder": "Seu sobrenome",
        "firstName": "Nome",
        "firstNamePlaceholder": "Seu nome",
        "birthDate": "Data de nascimento"
      },
      "language": {
        "label": "Idioma",
        "intro": "Escolha o idioma no qual deseja usar a Harmonia. A alteração é aplicada imediatamente em todo o aplicativo.",
        "options": {
          "fr": { "name": "Francês", "native": "Français" },
          "en": { "name": "Inglês", "native": "English" },
          "es": { "name": "Espanhol", "native": "Español" },
          "pt": { "name": "Português", "native": "Português" }
        }
      },
      "actions": {
        "cancel": "Cancelar",
        "save": "Salvar"
      },
      "errors": {
        "nameRequired": "Nome e sobrenome obrigatórios",
        "cannotSave": "Não foi possível salvar",
        "cannotChangeLanguage": "Não foi possível alterar o idioma"
      }
    }
  },
  "vueProfilModal": {
    "loading": "Carregando...",
    "memberSince": "Membro desde {{date}}",
    "premiumBadge": "Premium",
    "actions": {
      "sendInvite": "Enviar convite",
      "cancelRequest": "Cancelar pedido",
      "accept": "Aceitar",
      "decline": "Recusar",
      "removeFriend": "Remover amigo"
    },
    "errors": {
      "cannotLoadProfile": "Não foi possível carregar o perfil"
    }
  },
  "chatBox": {
    "retry": "Tentar novamente",
    "loadingData": "Carregando dados",
    "loadingEllipsis": "Carregando…",
    "loadPreviousMessages": "Ver mensagens anteriores",
    "messageDeleted": "Mensagem excluída",
    "privateReply": "Resposta privada",
    "edited": "editado",
    "offlineBanner": "Sem conexão — as mensagens serão reenviadas automaticamente",
    "status": {
      "typing": "Digitando...",
      "typingEllipsis": "Digitando…",
      "online": "Online",
      "offline": "Offline",
      "someoneTyping": "Alguém está digitando...",
      "someoneTypingEllipsis": "Alguém está digitando…",
      "memberCount_one": "{{count}} membro",
      "memberCount_other": "{{count}} membros"
    },
    "empty": {
      "title": "Nenhuma mensagem",
      "subtitle": "Inicie a conversa!"
    },
    "replyBar": {
      "publicPrefix": "Resposta pública a ",
      "privatePrefix": "Resposta privada a "
    },
    "editBar": {
      "label": "Editar mensagem"
    },
    "input": {
      "placeholder": "Mensagem...",
      "editPlaceholder": "Editar mensagem..."
    },
    "media": {
      "document": "Documento",
      "file": "Arquivo",
      "voiceNote": "Nota de voz"
    },
    "recording": {
      "inProgress": "Em andamento...",
      "inProgressEllipsis": "Gravando…"
    },
    "actions": {
      "replyPublicly": "Responder publicamente",
      "replyPubliclySub": "Todo o grupo vê a resposta",
      "replyPrivately": "Responder em privado",
      "replyPrivatelySub": "Visível apenas para você e o destinatário",
      "makePrivate": "Tornar privado",
      "makeVisible": "Tornar visível",
      "edit": "Editar",
      "editSub": "Possível enquanto não lida",
      "delete": "Excluir",
      "cancel": "Cancelar"
    },
    "errors": {
      "uploadUrlGeneration": "Erro ao gerar URL",
      "uploadFailed": "Erro durante o envio",
      "uploadFailedHttp": "Falha no envio (HTTP {{status}})",
      "uploadConfirmation": "Erro de confirmação",
      "transferFailed": "Erro durante a transferência do arquivo.",
      "microphonePermission": "Permissão de microfone necessária. Verifique as permissões do navegador.",
      "permissionRequired": "Permissão necessária.",
      "cannotStartRecording": "Não foi possível iniciar a gravação.",
      "audioFileCreation": "Erro ao criar o arquivo de áudio."
    }
  },
  "audioFeedModal": {
    "runNumber": "Run #{{number}}",
    "runLabel": "Run #{{number}} — {{title}}"
  },
  "tikTokVideoModal": {
    "runLabel": "Run #{{number}} — {{title}}"
  },
  "commentLikersModal": {
    "loading": "Carregando…",
    "likesCount_one": "curtida",
    "likesCount_other": "curtidas",
    "likedThisComment": "Curtiu este comentário",
    "likePill": "Curtir",
    "empty": {
      "title": "Nenhuma curtida por enquanto",
      "subtitle": "Seja o primeiro a reagir!"
    }
  },
  "limitNotification": {
    "titlePro": "Limite PRO atingido",
    "titleDaily": "Limite diário",
    "upgradeButton": "Tornar-se PRO"
  },
  "legalDocumentScreen": {
    "defaultBadgeText": "Documento legal oficial",
    "lastUpdated": "Última atualização: {{date}}",
    "sectionsLabel": "SEÇÕES",
    "copyright": "© {{year}} Harmonia · Todos os direitos reservados",
    "intro": {
      "title": "Sua privacidade, nossa prioridade",
      "text": "A Harmonia se compromete a proteger seus dados com o máximo rigor. Nenhum dado é vendido ou transmitido a terceiros comerciais."
    },
    "pills": {
      "zeroTracking": "Zero rastreamento",
      "encrypted": "Criptografado",
      "gdpr": "RGPD",
      "internalAdsOnly": "Apenas publicidade interna"
    },
    "contact": {
      "title": "Alguma dúvida sobre seus dados?"
    },
    "footer": {
      "privacy": "Privacidade",
      "cookies": "Cookies",
      "terms": "Termos",
      "rules": "Regras"
    }
  },
  "shareButton": {
    "title": "Compartilhar",
    "sharedOnHarmonia": "Compartilhado na Harmonia ✓",
    "shareWithFriends": "Compartilhar com meus amigos",
    "visibleInFriendsFeed": "Visível no feed dos seus amigos",
    "socialNetworks": "Redes sociais",
    "more": "Mais",
    "cancel": "Cancelar"
  },
  "submissionCard": {
    "runLabel": "Run #{{number}} — {{title}}",
    "vote": "Votar",
    "voted": "Votado 💪",
    "badges": {
      "arts": "🎨 Artes",
      "artisanat": "🪡 Artesanato"
    },
    "mediaBadges": {
      "audio": "Áudio",
      "video": "Vídeo",
      "artisanat": "Artesanato"
    }
  },
  "publicShopScreen": {
    "loadingShop": "Carregando a loja…",
    "newBadge": "Novo",
    "products": "Produtos",
    "noProducts": "Nenhum produto publicado no momento.",
    "subscribe": "Assinar",
    "retry": "Tentar novamente",
    "whatsappMessage": "Olá, estou descobrindo sua loja \"{{name}}\" na Harmonia Market.",
    "errors": {
      "shopNotFound": "Esta loja não existe ou não está mais disponível.",
      "cannotLoadShop": "Não foi possível carregar esta loja.",
      "cannotReachServer": "Não foi possível contatar o servidor."
    }
  },
  "publicProductScreen": {
    "loadingProduct": "Carregando o produto…",
    "newBadge": "Novo",
    "back": "Voltar",
    "retry": "Tentar novamente",
    "defaultMetaTitle": "Produto",
    "descriptionTitle": "Descrição",
    "inStock_one": "Em estoque ({{count}})",
    "inStock_other": "Em estoque ({{count}})",
    "outOfStock": "Sem estoque",
    "contactViaWhatsApp": "Contatar via WhatsApp",
    "buy": "Comprar",
    "learnMore": "Saiba mais",
    "call": "Ligar",
    "goToShop": "Ir para a loja",
    "whatsappMessage": "Olá, estou interessado(a) em \"{{name}}\" na Harmonia Market.",
    "condition": {
      "new": "Novo",
      "used": "Usado",
      "refurbished": "Recondicionado"
    },
    "errors": {
      "productNotFound": "Este produto não existe ou não está mais disponível.",
      "cannotLoadProduct": "Não foi possível carregar este produto.",
      "cannotReachServer": "Não foi possível contatar o servidor."
    }
  },
  "commentCaMarcheScreen": {
    "cta": "Criar minha conta gratuitamente",
    "seo": {
      "title": "Como funciona? Guia completo da Harmonia World",
      "description": "Descubra como funciona a Harmonia World: crie sua conta, participe de concursos de talentos em 6 disciplinas, junte-se a uma comunidade criativa ou crie sua loja online com seu próprio site profissional. Guia completo passo a passo.",
      "ogDescription": "Concursos de talentos, comunidade criativa, lojas online: o guia completo do funcionamento da Harmonia World."
    },
    "hero": {
      "titleLine1": "Como funciona",
      "titleLine2": "a Harmonia World?",
      "sub": "A Harmonia World é uma plataforma social que reúne três universos em um só lugar: concursos de talentos abertos a todos, uma comunidade criativa internacional e um marketplace que permite a qualquer pessoa criar sua própria loja online com um site profissional. Este guia explica em detalhes cada funcionalidade, passo a passo."
    },
    "presentation": {
      "chip": "APRESENTAÇÃO",
      "title": "Uma plataforma, três universos",
      "p1": "A Harmonia World está disponível na web e no celular. Ela permite que cada membro crie um perfil, publique conteúdo, interaja por meio de mensagens e grupos, participe de concursos de talentos em seis disciplinas, jogue jogos de cultura geral e estratégia e — para comerciantes, artesãos e empreendedores — crie uma loja online acompanhada de um verdadeiro site personalizável.",
      "p2": "A plataforma se baseia em uma convicção simples: o talento não tem fronteiras. Cada disciplina abre a porta para concursos regulares, onde os membros competem com gentileza, são apoiados pelo voto da comunidade e podem ver seu talento recompensado com troféus entregues publicamente."
    },
    "gettingStarted": {
      "chip": "COMEÇAR",
      "title": "Criar sua conta e fazer login",
      "step1": {
        "title": "Cadastro",
        "desc": "Crie sua conta com seu nome, sobrenome, endereço de email e uma data de nascimento, ou cadastre-se diretamente via Google em um clique. O cadastro está aberto a qualquer pessoa, em qualquer lugar do mundo, sem restrição de idade."
      },
      "step2": {
        "title": "Verificação do email",
        "desc": "Um email de confirmação é enviado automaticamente. Basta clicar no link recebido e voltar ao aplicativo para ativar definitivamente a conta."
      },
      "step3": {
        "title": "Login",
        "desc": "Uma vez ativada a conta, o login é feito com o email e a senha escolhidos. É possível permanecer conectado para evitar digitar novamente suas credenciais a cada abertura."
      },
      "step4": {
        "title": "Senha esquecida",
        "desc": "Em caso de esquecimento, um link de redefinição é enviado por email para escolher uma nova senha com segurança."
      }
    },
    "talentHub": {
      "chip": "CENTRO DE TALENTOS",
      "title": "Seis disciplinas, concursos toda semana",
      "p1": "O Centro de Talentos oferece concursos ativos distribuídos em seis grandes disciplinas. Toda semana, novos desafios são abertos a todos os membros. Os participantes enviam suas criações ou competem diretamente, e então a comunidade vota para escolher os melhores talentos. Os concursos que levam a uma etapa final presencial acontecem em um país escolhido aleatoriamente pela Harmonia, com um júri de especialistas selecionado para garantir a equidade.",
      "p2": "A Harmonia World não oferece nenhum jogo de azar. O objetivo exclusivo dos concursos é revelar e recompensar talentos reais, avaliados pelo voto da comunidade e, para as finais, por júris especializados."
    },
    "disciplines": {
      "strategie": {
        "label": "Jogos de Estratégia",
        "tagline": "Reflexão e tática pura",
        "desc": "Awalé e Damas: enfrente seus adversários em duelos de estratégia intensa."
      },
      "connaissance": {
        "label": "Conhecimentos",
        "tagline": "Teste seu saber",
        "desc": "Verdadeiro ou Falso: duelos intelectuais tão emocionantes quanto imprevisíveis."
      },
      "arts": {
        "label": "Artes",
        "tagline": "Criatividade e expressão",
        "desc": "Fotografia, Desenho, Design: exponha suas criações e receba o reconhecimento que merecem."
      },
      "performance": {
        "label": "Performance",
        "tagline": "Suba ao palco",
        "desc": "Comédia, Dança, Teatro: incorpore, cative, transcenda."
      },
      "musique": {
        "label": "Música",
        "tagline": "Faça o palco vibrar",
        "desc": "Canto, Piano, Violão: sua voz, seus instrumentos, sua marca no mundo."
      },
      "artisanat": {
        "label": "Artesanato",
        "tagline": "Saber-fazer de excelência",
        "desc": "Costura, Marcenaria, Cabeleireiro, Solda, Mecânica: profissões nobres, maestria rara."
      }
    },
    "community": {
      "chip": "COMUNIDADE",
      "title": "Publicar, interagir, fazer amigos",
      "p1": "O feed de notícias permite que cada membro publique conteúdo (texto, e para os membros PRO, fotos e vídeos) com um nível de visibilidade escolhido: público, visível apenas para amigos, para amigos de amigos, ou estritamente privado. As publicações podem ser curtidas, comentadas, compartilhadas e salvas.",
      "p2": "A Harmonia também oferece mensagens privadas e grupos de discussão, além de um sistema de amigos com sugestões, pesquisa de usuários e gerenciamento de pedidos enviados ou recebidos."
    },
    "proSolution": {
      "chip": "SOLUÇÃO PRO",
      "title": "Sua loja, seu site, seu mundo",
      "p1": "Os membros PRO podem criar uma loja diretamente pela Harmonia. Cada loja se torna um verdadeiro site, personalizável em seu layout, apresentação e identidade visual, acessível tanto pelo aplicativo quanto por um link público funcional na web — sem que os visitantes precisem de uma conta para consultar a loja ou seus produtos.",
      "step1": {
        "title": "Criar sua loja",
        "desc": "A partir do Market, os membros PRO acessam as configurações de sua loja e a publicam em poucas etapas."
      },
      "step2": {
        "title": "Personalizar seu site",
        "desc": "O design e muitos parâmetros do site associado à loja podem ser ajustados para refletir a identidade do comerciante, artesão ou empreendedor."
      },
      "step3": {
        "title": "Publicar produtos",
        "desc": "Cada produto adicionado tem automaticamente sua própria página e seu próprio link web, consultável e compartilhável independentemente da loja."
      },
      "step4": {
        "title": "Ser visível em todos os lugares",
        "desc": "O link da loja e o de cada produto podem ser compartilhados em qualquer plataforma, permitindo vender e trocar com clientes no mundo todo."
      }
    },
    "proStatus": {
      "chip": "STATUS PRO",
      "title": "O que o status PRO desbloqueia",
      "p1": "O status PRO permite publicar com mais frequência (3 publicações por dia contra 1 para membros padrão), adicionar fotos e vídeos às publicações, enviar mídias e notas de voz nas mensagens, e sobretudo criar uma loja online com seu próprio site público. Um selo distintivo torna o status visível no perfil."
    },
    "faq": {
      "chip": "PERGUNTAS FREQUENTES",
      "title": "Perguntas frequentes",
      "q1": {
        "question": "A Harmonia World é acessível em todo o mundo?",
        "answer": "Sim. O cadastro está aberto a qualquer pessoa no mundo, sem restrição de idade, e a plataforma está disponível na web e no celular."
      },
      "q2": {
        "question": "Os concursos são jogos de azar?",
        "answer": "Não. A Harmonia World não oferece nenhum jogo de azar. O objetivo exclusivo dos concursos é revelar e recompensar talentos reais graças ao voto da comunidade e, para as finais, a júris especializados."
      },
      "q3": {
        "question": "É preciso ter uma conta Harmonia para consultar uma loja?",
        "answer": "Não. Cada loja publicada dispõe de um link público funcional, consultável por qualquer visitante sem criação de conta."
      },
      "q4": {
        "question": "Qual é a diferença entre uma conta padrão e uma conta PRO?",
        "answer": "A conta PRO permite publicar mais, adicionar mídias enriquecidas às publicações e mensagens, e sobretudo criar uma loja online com seu próprio site público."
      }
    }
  }
}
